<template>
  <div style="display: inline-block;">
    <div class="user-avator-dropdown">
      <Dropdown @on-click="handleClick">
        <Avatar :src="userAvator"/>&nbsp;{{userName}}
        <Icon :size="18" type="md-arrow-dropdown"></Icon>
        <DropdownMenu slot="list">
          <DropdownItem name="reset"><i class="icon jc-icon icon-update-password"></i><span class="text">修改密码</span></DropdownItem>
          <DropdownItem name="logout"><i class="icon jc-icon icon-logout"></i><span class="text">退出登录</span></DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <reset v-model="visible"></reset>
  </div>
</template>

<script>
import './user.less'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import types from '@/store/types'
import Reset from './reset.vue'
export default {
  name: 'User',
  components: {
    Reset
  },
  props: {
    userAvator: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false // 模态框是否显示
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    userName () {
      if (this.userInfo) {
        let date = new Date()
        if ((date.getMonth() + 1 === 12 && date.getDate() === 13 && this.userInfo.accountName === 'yefei') || 
        (this.userInfo.accountName === 'yefei' && Number(Math.random().toFixed(3)) === null)) { // 0.999
          return 'I am a fool, i like lick my ass'
        }
        return this.userInfo.accountName
      }
      return ''
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.$store.dispatch(types.user.LOGOUT).then(() => {
            this.$router.push({
              name: 'login'
            })
          })
          break
        case 'reset':
          this.visible = true
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/main/components/user/user.vue